const state = () => ({
    data: []
})

// getters
const getters = {}

// actions
const actions = {
    // get records
    async get({state, commit}, {params} = {}) {
        const res = await this._vm.axios.get(this._vm.endpoint.get('library_video_group'), {
            params: params
        })

        const {data} = res.data

        state.data = data
    },
}

// mutations
const mutations = {

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
